import React from "react";
import { Switch } from "react-router-dom";
import { default as Route } from "../../../routes/CustomRoute";
import RankingTable from "./RankingTable";
import BalanceTable from "./Balance/BalanceTable";
import {
  withContainers,
  RankingsContainer,
  ClientContainer,
} from "../normalizer";
import RankingsSelector from "./RankingsSelector";
import RankingNavigation from "./RankingNavigation";
import { t } from "../../../i18n";

const getRanking = ({ rankings, match }) => {
  return rankings.find((r) => r.id.toString() === match.params.id);
};

const getRankingAdditonalInfo = (type, currencyLabel) => {
  let info = {};
  switch (type) {
    case "sales": {
      info.currencyLabel = t("gamification2026.rankings.sales");
      info.winnerDescription = t("gamification2026.rankings.sales-lowercase");
      break;
    }
    case "objectives": {
      info.currencyLabel = t("gamification2026.rankings.achievement");
      info.winnerDescription = t("gamification2026.rankings.pp");
      break;
    }
    default: {
      info.currencyLabel = `${currencyLabel} (#)`;
      info.winnerDescription = currencyLabel;
    }
  }
  return info;
};

const RankingsLayout = (props) => {
  const {
    campaignUser,
    points,
    user,
    userPosition,
    winners,
    rankings,
    userNeighbours,
    firstRanking,
    currPage,
    totalPages,
    onPageChange,
  } = props;

  const { currency_label: currencyLabel } = props.client;

  const ranking = getRanking(props) || {};
  const pointsLabel = getRankingAdditonalInfo(
    ranking.ranking_type,
    currencyLabel,
  );
  return (
    <div className="rankings-layout">
      <div className="rankings-layout-navigation">
        <RankingNavigation ranking={ranking} firstRanking={firstRanking} />
        <RankingsSelector rankings={rankings} />
      </div>
      <div className="rankings-layout-content">
        <Switch>
          <Route
            path={`/rankings/${ranking.id}`}
            exact
            rankingLabel={pointsLabel}
            component={RankingTable}
            user={user}
            campaignUser={campaignUser}
            winners={winners}
            userPosition={userPosition}
            userNeighbours={userNeighbours}
            endDate={ranking.end_date}
            isWinner={ranking.is_winner}
            winningMessage={ranking.winning_message}
            slug={props.client.slug}
            currPage={currPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
          <Route
            path={`/rankings/${ranking.id}/balance`}
            exact
            component={BalanceTable}
            rankingLabel={pointsLabel}
            points={points}
            page={currPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </Switch>
      </div>
    </div>
  );
};

export default withContainers(RankingsLayout, [
  RankingsContainer,
  ClientContainer,
]);
